// ...existing imports...
import React, { useState } from 'react';
import { IonList, IonItem, IonLabel, IonListHeader, useIonViewWillEnter } from '@ionic/react';
import { useAuth0 } from '@auth0/auth0-react';
import { listStreams } from '../services/api';
import LayoutWrapper from '../components/LayoutWrapper';

const StreamList: React.FC = () => {
  const [streams, setStreams] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const { getAccessTokenSilently } = useAuth0();

  const fetchStreams = async (token: string) => {
    setLoading(true);
    try {
      const data = await listStreams(token);
      setStreams(data);
    } catch {
      setStreams([]);
    }
    setLoading(false);
  };

  useIonViewWillEnter(() => {
    (async () => {
      const token = await getAccessTokenSilently();
      await fetchStreams(token);
    })();
  });

  return (
    <LayoutWrapper title="Streams">
      <IonList>
        <IonListHeader>
          <IonLabel>Meus Streams</IonLabel>
        </IonListHeader>
        {loading ? (
          <IonItem>
            <IonLabel>Carregando...</IonLabel>
          </IonItem>
        ) : streams.length === 0 ? (
          <IonItem>
            <IonLabel>Nenhum stream ativo.</IonLabel>
          </IonItem>
        ) : (
          streams.map((stream) => (
            <IonItem key={stream.id}>
              <IonLabel>
                <b>{stream.id}</b>
                <div style={{ fontSize: '0.9em', color: '#888' }}>{stream.rtsp_url}</div>
                <div style={{ fontSize: '0.9em', color: '#3880ff' }}>
                  HTTP: <a href={stream.http_url} target="_blank" rel="noopener noreferrer">{stream.http_url}</a>
                </div>
              </IonLabel>
            </IonItem>
          ))
        )}
      </IonList>
    </LayoutWrapper>
  );
};

export default StreamList;